import { experimentMetricActiveMocking } from '@gonfalon/dogfood-flags/dogfood-flags';
import { type GetExperimentExposureActiveQueryParams } from '@gonfalon/openapi/operations/getExperimentExposureActive';
import { getExperimentExposureActiveQuery } from '@gonfalon/rest-api/queries/usage';
import { useQuery } from '@tanstack/react-query';

export const useExperimentExposureActive = (
  params: {
    apiVersion?: string;
    query: GetExperimentExposureActiveQueryParams;
    projectKey: string;
    environmentKey: string;
  },
  options?: { enabled?: boolean; [key: string]: unknown },
) => {
  const mockingMode = experimentMetricActiveMocking();
  const { apiVersion, query, projectKey, environmentKey } = params;
  return useQuery({
    ...getExperimentExposureActiveQuery({ apiVersion, query, projectKey, environmentKey }),
    ...options,
    enabled: mockingMode === 'enabled' && options?.enabled !== false,
    placeholderData:
      mockingMode === 'true'
        ? { flagActive: true, metricActive: true }
        : mockingMode === 'false'
          ? { flagActive: false, metricActive: false }
          : undefined,
  });
};
